module.exports = __webpack_public_path__ + "static/3-c756a79f4eeca7bcccf317b08901a053.svg";